import React, { useState,useEffect } from 'react';
import {Box,Typography,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { useNavigate,Navigate } from 'react-router-dom';
import { add_test } from '../Redux/testSlice';
import { add_tests } from '../Redux/testsSlice';
import get_tests_all from "../Redux/reducers/get_tests_all"
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { add_assessment } from '../Redux/templatesSlice';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}

const MaxText = ({navigate,dispatch,tst,text,limit,setVisible})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button onClick={(e)=>{
	  e?.preventDefault()
	  setVisible(false)
	  dispatch(add_test(tst))
	  if(tst?.isTest){
		navigate("/testInfo")
	  }else{
		dispatch(add_assessment(tst))
		navigate("/assessmentInfo")
	  }
	}}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
  }

const AssessmentDialog = ({visible,setVisible})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [loading,setLoading] = useState(false)
const dispatch = useDispatch()
const [results, setResults] = useState([]);
const navigate = useNavigate()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

useEffect(()=>{
	get_tests_all(user?.email,setResults,add_tests,dispatch,user?.accessToken,setLoading)
},[])


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Assessments
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			<Box justifyContent="center" alignItems="center" width="100%">
				{
				(results?.length == 0 && !loading) && (
					<Box justifyContent="center" alignItems="center" width="100%" p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img  width={50} height={80} src={require("../assets/yes.gif")} alt="keep up" />
						</Box>
						<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5}}>
							Assessments were not found
						</Typography> 
						<Box justifyContent="cxenter" alignItems="center" width="100%" mt={1}> 
	                        <Button onClick={(e)=>{
	                            e?.preventDefault()
	                            navigate("/createTest")
	                          }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
	                            Create now
	                        </Button>
	                    </Box>  
					</Box>
					)
				}
				{
				(results?.length == 0 && loading) && (
					<Box justifyContent="center" alignItems="center" width="100%" p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img width={50} height={80} src={require("../assets/yes.gif")} alt="keep up" />
						</Box>
						<Typography style={{fontWeight:500,fontSize:13,color:'white',marginTop:5}}>
							Wait a moment ...
						</Typography> 
					</Box>
					)
				} 
				{
				results?.map((item,index)=>{
					return(
					<Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"100%",justifyContent:"flex-start",alignContent:"flex-start"}}>
						<MaxText setVisible={setVisible} navigate={navigate} dispatch={dispatch} tst={item} text={`# ${index+1}  ${item?.name}`} limit={40}/>
						<Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" width="100%" mt={1}>
							<Box>
								<QuizOutlined fontSize='small'/>
								<Typography sx={{fontSize:10,fontWeight:400}}>
									{item?.level}
								</Typography>
							</Box>
							<Box>
								<CalendarTodayOutlined fontSize='small'/>
								<Typography sx={{fontSize:10,fontWeight:400}}>
									{item?.start_date}
								</Typography>
							</Box>
							<Box>
								<Alarm fontSize='small'/>
								<Typography sx={{fontSize:10,fontWeight:400}}>
									{item?.start_moment}
								</Typography>
							</Box>
						</Box>
						<DescriptionText text={item?.description} limit={55}/>
					</Box>
					)
				})
	            }		
			</Box>
		</DialogContent>
	</Dialog>
	)
}

export default AssessmentDialog